<template>
  <article class="select">
    <div
      class="select-control"
      :class="{ 'focused': isFocused }"
      ref="control"
      :tabIndex='1'
      @click="toggleDropdown('toggle')"
      v-click-outside="toggleDropdown"
    >
      <span :class="['select-placeholder', {'searchInput-cursor': searchInput}]" v-show="showPlaceholder">
        {{ placeholder }}
      </span>

      <!-- <span
        v-for="(item, index) in items"
        :key="index"
        :class="['select-item', multiple ? 'multiple' : 'single']"
        @mousedown.prevent="selectedItemIndex = index"
      >
        <slot name="item" :item="item">
          {{ item.label }}
        </slot>
      </span> -->

      <input
        v-if="searchInput"
        ref="search"
        v-model="search"
        @click.stop="onSearchFocus"
        type="text"
        class="select-input"
      />

      <div class="select-item" v-show="showSelectItem">
        {{ viewValues }}
      </div>

      <span
        ref="ghost"
        class="select-input select-inputGhost"
        v-html="ghostValue"
      ></span>

      <span class="image" style="-webkit-mask: url('/static/img/common/caret_down.svg') no-repeat center / contain"></span>
    </div>

    <div class="select-dropdown" v-show="showDropdown" ref="list">
      <div
          v-for="(option, index) in availableOptions"
          :key="index"
          ref="options"
          class="select-option"
          :class="[{ 'selected': selectedOptionIndex === index }, { 'chosen': items.some(item => item.value === option.value) }, { 'select-all': option.value === 'all' }, multiple ? 'multiple' : 'single']"
          @click.stop="toggle(option)"
          @mouseenter="selectedOptionIndex = index"
        >
          <slot name="option" :option="option">

            <span v-if="option.value === 'all' && items.length === options.length - 1">取消全部</span>
            <span v-else>{{ option.label }}</span>
          </slot>
        </div>

      <slot name="noResults" v-if="search && !availableOptions.length">
        <div class="select-noResults">{{ noResults }}</div>
      </slot>
    </div>

  </article>
</template>

<script>
export default {
  name: "Selects",
  model: {
    prop: 'values',
    event: 'change'
  },
  props: {
    options: {
      type: Array,
      required: true,
      default () {
        return []
      }
    },
    values: {
      type: Array,
      required: false,
      default: []
    },
    placeholder: {
      type: String,
      required: false,
      default: '請選擇'
    },
    noResults: {
      type: String,
      required: false,
      default: '沒有相關搜尋結果'
    },
    multiple: { // 是否多選
      type: Boolean,
      required: false,
      default: false
    },
    searchInput: { // 是否要有搜尋
      type: Boolean,
      required: false,
      default: false
    },
    showSelectedData: { // 只顯示選中的資料
      type: Boolean,
      required: false,
      default: false
    },
    isFrontFilter: { // 是否前端篩選
      type: Boolean,
      required: false,
      default: true
    }
  },
  data () {
    return {
      search: '',
      searchWidth: 4,
      controlWidth: 100,
      selectedItemIndex: -1,
      selectedOptionIndex: -1,
      isFocused: false,
      isInputFocused: false,
      // values: [],
      // viewValues: '',
      temporaryOption: [] // 暫存選單(後端篩選用)
    }
  },
  computed: {
    items() {
      const options = this.isFrontFilter ? this.options : this.temporaryOption;
      return this.values.map((val) => {
        // let find_option = _.find(options, { 'value': val });
        let find_option = options.find(option => option.value === val);
        if (!find_option) {
          return {
            label: '無此選項',
            value: undefined
          }
        }
        return find_option;
      })
    },
    availableOptions() {
      const search = this.search.toLowerCase().trim();

      if (this.showSelectedData) {
        if (search) {
          return this.options
        } else {
          return this.items;
        }
      } else {
        return this.options.filter((opt) => {
          return (!search || opt.label.toLowerCase().indexOf(search) >= 0);
        })
      }
    },
    selectedData() {
      const search = this.search.toLowerCase().trim();

      let options = this.options.filter((opt) => {
        return (!search || opt.label.toLowerCase().indexOf(search) >= 0);
      })

      if (search && options.length > 0 && this.showSelectedData) return true;
      else if (!this.showSelectedData) return true;
      else return false;
    },
    ghostValue() {
      return this.search.replace(/\s/g, '&nbsp;');
    },
    searchStyle() {
      return {
        width: (this.searchWidth + 40) + 'px',
        maxWidth: (this.controlWidth - 14) + 'px'
      }
    },
    showDropdown() {
      return this.isFocused && (this.availableOptions.length || this.search)
    },
    showPlaceholder() {
      return ((!this.search.trim() && !this.items.length) && this.search === '') && !this.isInputFocused;
    },
    showSelectItem() {
      return !this.isInputFocused;
    },
    viewValues() {
      const options = this.isFrontFilter ? this.options : this.temporaryOption;

      if (this.values.length > 0) {
        return this.values.map((val) => {
          // let find_option = _.find(options, { 'value': val });
           let find_option = options.find(option => option.value === val);
          if (!find_option) {
            return '無此選項';
          }
          return find_option.label;
        }).join(',');
      }
    }
  },
  watch: {
    search(text) {
      this.$nextTick(function () {
        this.searchWidth = this.$refs.ghost.offsetWidth;
        this.controlWidth = this.$refs.control.offsetWidth;

        if (!this.isFrontFilter) {
          this.$emit('search', text);
        }
      })
    },
    isFocused(isFocused) {
      if (isFocused) {
        this.$nextTick(function () {
          this.$refs.list.scrollTop = 0;
          this.selectedOptionIndex = 0  ;
        })
      } else {
        this.selectedItemIndex = -1;
        this.selectedOptionIndex = -1;
      }
    }
  },
  created() {
    document.addEventListener('keydown', this.docKeyDown);
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.docKeyDown);
  },
  methods: {
    // 下拉選單開關
    toggleDropdown(status = '') {
      if (status === 'toggle') {
        this.isFocused = !this.isFocused;
        this.scrollToSelected();
      }
      else if (status === 'open') {
        this.isFocused = true;
        this.scrollToSelected();
      }
      else {
        this.isFocused = false;
        this.isInputFocused = false
      }

      
    },
    toggle(option) {
      const list = this.values.slice();
      const value = this.getOptionValue(option);
      const index = this.getOptionIndex(this.items, option);
      const options = this.isFrontFilter ? this.options : this.temporaryOption;
      let change_value = [];

      // 是否多選
      if (this.multiple) {
        // 是否選擇到 全部
        if (value === 'all') {
          if (this.items.length === options.length - 1) {
            // 取消全選
            change_value = [];
          } else {
            // 全選
            change_value = options.filter((opt) => {
              return opt.value !== 'all';
            }).map(item => {
              return item.value;
            });
          }
        } else {
          if (index >= 0) {
            list.splice(index, 1);
          } else {
            list.push(value);
          }

          change_value = list;
        }
      } else {
        this.isFocused = false;
        
        change_value = [value];
      }
      
      // 是否前端篩選
      if(!this.isFrontFilter) {
         if (index >= 0) {
            this.temporaryOption.splice(index, 1);
          } else {
            this.temporaryOption.push(option);
          }
      }

      // this.viewValues = this.values.map((val) => {
      //   return _.find(options, { 'value': val }).label;
      // }).join(',');

      this.$emit('change', change_value);
      if (this.searchInput) this.onSearchBlur();
      this.$refs.control.focus();
    },
    // scrollIntoView(option) {
    //   // 使用适当的选择器来获取对应选项的 DOM 元素
    //   var selectedElement = document.querySelector('.select-dropdown .chosen');
    //   if (selectedElement) {
    //     selectedElement.scrollIntoView({ behavior: 'smooth' });
    //   }
    // },
    getOptionValue(option) {
      return option.value;
    },
    getOptionIndex(options, option) {
      const value = option.value;

      for (let i = 0, len = options.length; i < len; i++) {
        if (options[i].value === value) {
          return i;
        }
      }

      return -1;
    },
    focusSearch() {
      this.$refs.search.focus();
    },
    onControlClick() {
      if (this.multiple) this.focusSearch();
      else this.isFocused = true;
    },
    onSearchFocus() {
      this.isInputFocused = true;
      this.toggleDropdown('open');
    },
    onSearchBlur() {
      // this.isFocused = false;
      this.isInputFocused = false;
      this.search = '';
    },
    scrollToSelected() {
      
      this.$nextTick(() => {

        // const el = this.$refs.options[this.selectedOptionIndex];

        // if (el && el.scrollIntoView) {
        //   el.scrollIntoView();
        // }
        // var selectedElement = document.querySelector('.select-dropdown .chosen');
        const that = this;
        setTimeout(() => {
          const index = that.options.map(item => item.value).indexOf(that.items.map(item => item.value)[0])

          const el = this.$refs.options[index];

          if (el && el.scrollIntoView) {
            
            el.scrollIntoView({ block: 'nearest', inline: 'start' })
          }
        }, 200)
      })
    },
    blur() {
      this.$refs.search.blur();
      this.search = '';  
    },
    docKeyDown(event) {
      // console.log('docKeyDown', event.key, event.keyCode)
      const itemCount = this.items.length;
      const availableOptionCount = this.availableOptions.length;
      
      if (this.selectedItemIndex >= 0) {
        if (event.key === 'Backspace' || event.key === 'Delete') {
          this.toggle(this.items[this.selectedItemIndex]);
          this.selectedItemIndex = -1;
        } else if (event.key === 'ArrowLeft') {
          this.selectedItemIndex --;
        } else if (event.key === 'ArrowRight') {
          this.selectedItemIndex ++;
        }
        
        if (this.selectedItemIndex < -1) {
          this.selectedItemIndex = -1;
        } else if (this.selectedItemIndex >= itemCount) {
          this.selectedItemIndex = -1;
          this.focusSearch();
        }
      }
      
      if (this.isFocused) {
        if (event.key === 'Escape') {
          this.onSearchBlur();
          return;
        }
      }

      // Only when the search input is focused.
      if (document.activeElement === this.$refs.search) {
        // Remove last item when BACKSPACE is pressed and there
        // is no search text.
        // if (itemCount > 0 && event.key === 'Backspace' && !this.search) {
        //   this.toggle(this.items[itemCount - 1]);
        // }
        // // Handle navigating up and down the available options
        // // when the user presses the UP and DOWN arrow keys.
        // if (availableOptionCount > 0) {
        //   if (event.key === 'ArrowUp') {
        //     if (this.selectedOptionIndex > 0) {
        //       this.selectedOptionIndex --;
        //       this.scrollToSelected();
        //     }
        //   } else if (event.key === 'ArrowDown') {
        //     if (this.selectedOptionIndex < availableOptionCount - 1) {
        //       this.selectedOptionIndex ++;
        //       this.scrollToSelected();
        //     }
        //   }
        // }
        // Handle ENTER key to select current option index.
        // if (event.key === 'Enter' && this.selectedOptionIndex >= 0) {
        //   this.toggle(this.availableOptions[this.selectedOptionIndex])
        //   // Selected nothing if we selected the only remaining option.
        //   if (this.selectedOptionIndex === 0 && availableOptionCount === 1) {
        //     this.selectedOptionIndex = -1;
        //   }
        //   // Update the selected option index to the previous available option
        //   // if the last option has been toggled.
        //   else if (this.selectedOptionIndex === availableOptionCount - 1) {
        //     // Update to the previous index or -1.
        //     this.selectedOptionIndex = Math.max(-1, this.selectedOptionIndex - 1)
        //   }
        //   this.search = '';
        // }
      }
    }
  }
};
</script>

<style lang="sass" scoped>
.select 
  position: relative
  max-width: 300px
  cursor: pointer
.select-control 
  max-width: 240px
  min-height: 34px
  padding: 0 28px 0px 20px
  box-sizing: border-box
  display: flex
  justify-content: left
  align-items: center
  // flex-flow: wrap
  border: 1px solid rgba(157, 172, 198, 0.4)
  border-radius: 18px
  font-size: 14px
  &.focused
    border: 1px solid #2D3A51
    .image
      background-color: #2D3A51
  &:focus
    outline : none
  .image
    content: ''
    position: absolute
    right: 15px
    background-color: rgba(157, 172, 198, 0.5)
    width: 8px
    height: 8px
.select-input 
  width: 192px
  font-size: 14px
  background-color: transparent
  position: absolute
.select-inputGhost 
  position: absolute 
  top: 0 
  left: 0 
  z-index: -1 
  width: auto 
  visibility: hidden 
.select-placeholder
  position: absolute
.searchInput-cursor
  cursor: text
.select-item 
  // display: inline-block 
  // margin: 3px 
  // padding: 3px 5px 
  // border-radius: 3px 
  // cursor: pointer
  white-space: nowrap
  overflow-x: hidden
  white-space: nowrap
  pointer-events: none
  &.single
    color: #2D3A51
  &.multiple
    background: #eee
    color: #2D3A51
.select-dropdown 
  position: absolute 
  top: calc(100% + 10px)
  z-index: 999 
  width: 100% 
  max-height: 322px 
  overflow: auto 
  border-radius: 12px
  box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.1)
  border: 1px solid #2D3A51
  background-color: #fff
  user-select: none
.select-noResults 
  padding: 3px 20px 
  font-style: italic 
  text-align: center 
.select-option
  height: 40px
  display: flex
  justify-content: left
  align-items: center
  padding: 0 55px 0 39px
  font-size: 13px
  color: #787d92
  white-space: nowrap
  &:hover 
    cursor: pointer
  &.select-all
    color: #2d3a51
    background-color: rgba(157, 172, 198, 0.2)
  &.selected
    background: #2D3A51
    color: #FFFFFF
    &:not(.single):after
      content: 'select'
      position: absolute
      color: #FFFFFF
      right: 9px
      font-size: 12px
  &.single:not(.selected)
    &.chosen
      // color: #2D3A51
      color: #FFFFFF
      background: rgba(255, 84, 75, 0.9)
  &.multiple
    &.chosen
      background: rgba(255, 84, 75, 0.9)
      color: #FFFFFF
      &:before
        position: absolute
        left: 19px
        content: ''
        position: absolute
        -webkit-mask: url('/static/img/common/tick.svg') no-repeat center / contain
        width: 10px
        height: 10px
        background-color: #FFFFFF
      &:after
        content: 'remove'
        position: absolute
        color: #FFFFFF
        right: 9px
        font-size: 12px
</style>


// WEBPACK FOOTER //
// src/components/common/Selects.vue